// extracted by mini-css-extract-plugin
export var background = "bt_y";
export var backgroundContainer = "bt_fw";
export var bottomImage = "bt_t";
export var bottomImageContainer = "bt_fB";
export var buttons = "bt_cG";
export var container = "bt_b";
export var imagesContainer = "bt_fz";
export var middleWave = "bt_cS";
export var section = "bt_d";
export var text = "bt_cm";
export var textContainer = "bt_b1";
export var title = "bt_h";
export var topImage = "bt_m";
export var waveOverlay = "bt_fy";